export const FORMAT = {
  DATE: {
    CONTRACT: "YYYY/MM/DD",
    LONG: "YYYY/MM/DD HH:mm",
    MEMO: "YYYY/MM/DD",
    PLACEHOLDER: "YYYY年MM月DD日",
    QUERY: "YYYY/MM/DD",
    SHORT: "YYYY/MM/DD",
    SQL: "YYYY-MM-DD",
    TIMESTAMP: "YYYY-MM-DD HH:mm:ss",
  },
}
